const invertedMessages = {
  'Welcome to Identity Verification': 'external.anonymous.text.welcomeIV',
  'Identity Verification Setup Session Expired':
    'external.anonymous.text.expiredIV',
  'If you need to access the below link to this page again, please reach out to your organization’s support team.':
    'external.anonymous.text.expired.subText',
  'To begin the identity verification process, you will be securely redirected to Identity Verification website to complete your identity verification.':
    'external.anonymous.text.subTextIV',
  'Start Identity Verification': 'external.anonymous.startIV',
  'Start Identity Verification on IDDataweb': 'external.anonymous.start.btnIV',
  'One-time access only!': 'external.anonymous.confirmation.title',
  'This link can only be accessed once. After clicking, it will no longer be available. Please keep your information ready for identity verification before proceeding.':
    'external.anonymous.confirmation.subtitleIV',
  Apply: 'external.idp.apply',
  Cancel: 'external.idp.cancel',
};

export default invertedMessages;
